/**
 * The modal an app opened for me in the open workspace (WorkspaceViewModel.modal; Slack's modals). Mounted once by
 * WorkspaceRoot; it shows whenever a stack opened from this client (or already open here) has views.
 */
import type { RichTextContext, WorkspaceViewModel } from "@bundle/core";
import { AppModal, useViewModel } from "@bundle/ui";
import { useMemo } from "react";

const openLink = (url: string) => void window.open(url, "_blank", "noopener,noreferrer");

export function AppModalHost({ ws }: { ws: WorkspaceViewModel }) {
  const state = useViewModel(ws.modal);
  const wsState = useViewModel(ws);
  const cache = wsState.cache;
  const ctx = useMemo<RichTextContext>(
    () => ({ meId: wsState.meId, members: cache?.members ?? {}, channels: cache?.channels ?? {}, userGroups: cache?.userGroups ?? {} }),
    [wsState.meId, cache?.members, cache?.channels, cache?.userGroups],
  );
  if (state.stack === undefined) return null;
  return <AppModal vm={ws.modal} state={state} ctx={ctx} openUrl={openLink} testID="app-modal" />;
}
